export default function formatCurrency(e) {

  let valor = e

  valor += ''
  valor = Number(valor.replace(/[\D]+/g, ''))
  valor += ''
  valor = valor.replace(/([0-9]{2})$/g, ',$1')

  if (valor.length > 6) {
    valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2')
  }

  if (!valor || valor === '' || Number.isNaN(valor)) {
    return 0
  }
  if (valor.length === 3) {
    if (valor[0] === ',') {
      return `${0}${valor}`
    }
    return valor
  }
  return valor

}
